__turbopack_context__.v({
  "fade-in": "FocusSkip-module-scss-module__o2xNlG__fade-in",
  "focusSkip": "FocusSkip-module-scss-module__o2xNlG__focusSkip",
  "no-transform": "FocusSkip-module-scss-module__o2xNlG__no-transform",
  "rotate": "FocusSkip-module-scss-module__o2xNlG__rotate",
});
